import http from './axiosConfig' //引入基础配置
import { newBaseUrl as baseUrl } from "./api";
let getData = {}
  //查询评论列表 -- 张  
  getData.Akcomslist = (data)=>{ 
    return http.get(baseUrl+"/one/kcoms/",{ params:data })
  }
  //创建/回复评论 -- 张  
  getData.ACcoms = (data)=>{ 
    return http.post(baseUrl+"/one/kcoms/",data)
  }
  //删除评论 -- 张  
  getData.ADcoms = (pk,data)=>{ 
    return http.delete(baseUrl+"/one/kcom/"+pk+"/",data)
  }
export default getData


// WEBPACK FOOTER //
// ./src/common/article.js